import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanClave'
})
export class CleanClavePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    let clave = '';
    let response = '';

    let caracteres: any[] = ["/", "#", "%", "?", "[", "]", "'", " ", "<", ">",];

    //  / = lo toma como otra ruta
    //  # = lo toma como un espacion %
    //  % = lo toma como espacio  %25
    //  \ = lo toma como una subcarpeta
    //  ? = lo toma como un separador empieza a buscar despues del signo de ?
    //  [ = te agrega el siguiente codigo %5bE%
    //  % = lo toma como un separador
    //  ] = %5bE%
    //  ' = angular te toma ese caracter como si estuvieras abriendo y cerrando comillas siemples o declarando un string;
    //  < > = lo toma como %3

    let k: number = 0;

    while (k < caracteres.length) {
      while (value.includes(caracteres[k])) {
        value = value.replace(caracteres[k], '_');
      }
      k++;
    }
    clave = value;

    if (args[0] === 'url') {
      response = 'https://storagemultimedia.net/imagenes_pagina/Integradora/imagenes_fichas/' + clave + '_1.webp';
    } else if (args[0] === 'alone') {
      response = clave;
    }
    return response;
  }
}
